import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SupplierOwner from "services/Setup/Supplier/SupplierOwnerService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  supplierOwnerSliceList: [],
  response: [],
  subSupplerList: [],
  getCount: 0,
};

export const getSupplerItemSerch = createAsyncThunk(
  "supplierOwnerSlice/getSupplerItemSerch",
  async (data, { rejectWithValue }) => {
    const response = await SupplierOwner.getSupplerItemSerch(data);
    if (response) {
      return response.data;
    } else {
      console.log("errorresponsegetSupplerItemSerch");
      return { data: "None" };
    }
  }
);
// export const addtSupplerOwner = createAsyncThunk(
//   "supplierOwnerSlice/addtSupplerOwner",
//   async (data, { rejectWithValue }) => {
//     const response = await SupplierOwner.addSupplierOwner(data);
//     console.log("🚀 ~ responseaddtSupplerOwner:", response);
//     if (response) {
//       return response.data;
//     } else {
//       console.log("errorresponseaddtSupplerOwner");
//       return { data: "None" };
//     }
//   }
// );

export const addtSupplerOwner = createAsyncThunk(
  "supplierOwnerSlice/addtSupplerOwner",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SupplierOwner.addSupplierOwner(data);
      console.log("addtSupplerOwner", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const updateSupplerOwner = createAsyncThunk(
  "supplierOwnerSlice/updateSupplerOwner",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ updateSupplerOwner:", data);
    try {
      const response = await SupplierOwner.updateSupplerOwner(data);
      console.log("updateSupplerOwner", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const returnSupplierOwner = createAsyncThunk(
  "supplierOwnerSlice/returnSupplierOwner",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ datareturnSupplierOwnerslice:", data);
    try {
      const response = await SupplierOwner.returnSupplierOwner(data);
      console.log("returnSupplierOwner", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const approvalSupplierOwner = createAsyncThunk(
  "supplierOwnerSlice/approvalSupplierOwner",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SupplierOwner.approvalSupplierOwner(data);
      console.log("approvalSupplierOwner", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getSupplerItem = createAsyncThunk(
  "supplierOwnerSlice/getSupplerItem",
  async (data, { rejectWithValue }) => {
    const response = await SupplierOwner.getSupplerItem(data, {
      rejectWithValue,
    });
    if (response) {
      return response.data;
    } else {
      return { data: "None" };
    }
  }
);

export const getSupplerApproval = createAsyncThunk(
  "supplierOwnerSlice/getSupplerApproval",
  async (data, { rejectWithValue }) => {
    const response = await SupplierOwner.getSupplerApproval(data, {
      rejectWithValue,
    });
    if (response) {
      return response.data;
    } else {
      console.log("errorresponsegetSupplerApproval");
      return { data: "None" };
    }
  }
);

export const supplierReturn = createAsyncThunk(
  "supplierOwnerSlice/supplierReturn",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ supplierReturndata:", data);
    try {
      const response = await SupplierOwner.supplierReturn(data);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const RejectSupplerOwner = createAsyncThunk(
  "supplierOwnerSlice/RejectSupplerOwner",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ RejectSupplerOwnerdata:", data);
    try {
      const response = await SupplierOwner.RejectSupplerOwner(data);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const SupplierRequestOwner = createAsyncThunk(
  "supplierOwnerSlice/SupplierRequestOwner",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ SupplierRequestOwnerdata:", data);
    try {
      const response = await SupplierOwner.SupplierRequestOwner(data);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const SupplerApproval = createAsyncThunk(
  "supplierOwnerSlice/SupplerApproval",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SupplierOwner.SupplerApproval(data);
      console.log("SupplerApproval", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const deleteSupplierOwner = createAsyncThunk(
  "supplierOwnerSlice/deleteSupplierOwner",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SupplierOwner.deleteSupplierOwner(data);
      console.log("deleteSupplierOwner", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);
export const supplierOwnerSlice = createSlice({
  name: "supplierOwnerSlice",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    falseMessage: (state) => {
      state.message = "";
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // get supplier item
      .addCase(getSupplerItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupplerItem.fulfilled, (state, action) => {
        // console.log(
        //   "🚀 ~ .addCasegetSupplerItem ~ action:",
        //   action.payload.count
        // );
        state.loading = false;
        state.subSupplerList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getSupplerItem.rejected, (state, action) => {
        state.loading = false;
        state.response = action.payload;
        state.showMessage = true;
      })
      // get supplier item
      .addCase(getSupplerItemSerch.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupplerItemSerch.fulfilled, (state, action) => {
        // console.log(
        //   "🚀 ~ .addCasegetSupplerItemSerch ~ action:",
        //   action.payload.count
        // );
        state.loading = false;
        state.subSupplerList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getSupplerItemSerch.rejected, (state, action) => {
        state.loading = false;
        state.response = action.payload;
        state.showMessage = true;
      })
      // Get supplier approval
      .addCase(getSupplerApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupplerApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.subSupplerList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getSupplerApproval.rejected, (state, action) => {
        state.loading = false;
        state.response = action.payload;
        state.showMessage = true;
      })
      //Add Supplier
      .addCase(addtSupplerOwner.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(addtSupplerOwner.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(addtSupplerOwner.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Delete Supplier
      .addCase(deleteSupplierOwner.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(deleteSupplierOwner.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(deleteSupplierOwner.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Update Supplier
      .addCase(updateSupplerOwner.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(updateSupplerOwner.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(updateSupplerOwner.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Return
      .addCase(returnSupplierOwner.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(returnSupplierOwner.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(returnSupplierOwner.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Approval
      .addCase(approvalSupplierOwner.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(approvalSupplierOwner.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(approvalSupplierOwner.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Return
      .addCase(RejectSupplerOwner.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(RejectSupplerOwner.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(RejectSupplerOwner.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Request
      .addCase(SupplierRequestOwner.pending, (state) => {
        state.loading = true;
        state.message = "";
      })
      .addCase(SupplierRequestOwner.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(SupplierRequestOwner.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showLoading, falseMessage, showNotification, hideNotification } =
  supplierOwnerSlice.actions;

export default supplierOwnerSlice.reducer;
